var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
export var Sparkles = function (_a) {
    var color = _a.color, size = _a.size;
    return (_jsx("svg", __assign({ width: size, height: size, viewBox: "0 0 14 14", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: _jsx("path", { d: "M8.84615 13C9.59528 9.90078 10.5043 8.9342 13 8.09091C10.3776 7.20557 9.55971 6.13127 8.84615 3.18182C8.09702 6.28103 7.188 7.24762 4.69231 8.09091C7.31157 8.97518 8.13412 10.0568 8.84615 13ZM3.30769 6.45455C3.64927 4.84138 4.30924 4.11318 5.61538 3.72727C4.30924 3.34137 3.64927 2.61317 3.30769 1C2.98088 2.54344 2.36499 3.32359 1 3.72727C2.30599 4.11351 2.96611 4.84137 3.30769 6.45455Z", fill: color, stroke: color, strokeWidth: "1.2", strokeLinecap: "round", strokeLinejoin: "round" }) })));
};
